'use client';

import { Portal, Select, SelectRootProps } from '@chakra-ui/react';

const MultiSelect = ({ placeholder, ...props }: Props) => {
   return (
      <Select.Root {...props} bg="#2D2D2D" borderRadius="12px">
         <Select.HiddenSelect />
         <Select.Control>
            <Select.Trigger cursor="pointer" border="none">
               <Select.ValueText placeholder={placeholder} textTransform="capitalize" />
            </Select.Trigger>
            <Select.IndicatorGroup>
               <Select.Indicator />
            </Select.IndicatorGroup>
         </Select.Control>
         <Portal>
            <Select.Positioner>
               <Select.Content bg="#2D2D2D">
                  {props.collection.items.map(item => (
                     <Select.Item
                        textTransform="capitalize"
                        color="white"
                        cursor="pointer"
                        _hover={{ bg: '#3B3B3B' }}
                        item={item}
                        key={item.value}
                     >
                        {item.label}
                        <Select.ItemIndicator />
                     </Select.Item>
                  ))}
               </Select.Content>
            </Select.Positioner>
         </Portal>
      </Select.Root>
   );
};

export default MultiSelect;

type Props = {
   placeholder: string;
} & SelectRootProps;
